export const loaderAnimation = {
  left: {
    x: '-100%',
  },
  right: {
    x: '100%',
  },
}
